/**
 * TagInput 輸入拆分工具（與資料格式無關）。
 * 標籤陣列 ↔ 後端字串的轉換由各業務自行處理（例：報修配件 accessoriesTags.js）。
 */

/** 輸入／貼上時視為「結束一個標籤」的字元（換行、逗號、全形逗號、頓號） */
const DELIMITER_PATTERN = /[\n\r,，、]/;

export function hasTagDelimiter(text) {
  return DELIMITER_PATTERN.test(text ?? '');
}

/**
 * 使用者輸入／貼上的文字拆成「已完成」與「尚在輸入」兩部分。
 * 最後一段（最後一個分隔符之後）視為草稿，不轉標籤。
 * @returns {{ committed: string[], draft: string }}
 */
export function splitTagInput(text) {
  const raw = typeof text === 'string' ? text : '';
  const parts = raw.split(/[\n\r,，、]/);
  const draft = parts.pop() ?? '';
  const committed = parts.map((part) => part.trim()).filter(Boolean);
  return { committed, draft };
}
